import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArticleIcon from "@mui/icons-material/Article";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import MicIcon from "@mui/icons-material/Mic";
export const listData = [
  {
    id: 10,
    text: "Lorem ipsum dolor sit amet",
    icon: <TrendingUpIcon />,
  },
  {
    id: 1,
    text: "Lorem ipsum dolor sit amet",
    icon: <ArticleIcon />,
  },
  {
    id: 2,
    text: "Lorem ipsum dolor sit amet",
    icon: <EqualizerIcon />,
  },
  {
    id: 3,
    text: "Lorem ipsum dolor sit amet",
    icon: <MicIcon />,
  },
];
